import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-word",
  "use": "icon-word-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-word\"><defs><style type=\"text/css\"></style></defs><path d=\"M921.6 89.6v832h-832v-832h832zM832 179.328H179.2v652.544H832V179.328zM362.368 341.76l46.72 171.008 46.848-171.008h84.416l46.784 171.008 46.784-171.008h84.48l-88.064 328.896H544l-45.76-171.2-45.824 171.2h-86.4l-88-328.96h84.416z\" p-id=\"9117\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol